
import React from "react";
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Navbar from "../components/navbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import "./pages.css";
import imageList from '../imageList.json';


function Prices() {
  return (
    <div className="pages__container">
    <Container className="header__section">
      <Row >
        <Navbar />
      </Row>
    </Container>
    <Container>
      <Row className="body__container">
          <CardGroup className="price--group">
            {imageList.map((imagePath, index) => (
              (imagePath.indexOf('prices') !== -1) && 
                  <Row className="col-12 ">
                    <Card.Img key={index} src={`/images/${imagePath}`} alt={`Image ${index}`}   className="prices"/>
                  </Row>
              ))}
          </CardGroup>
      </Row>
    </Container>
  </div>
  );
}

export default Prices;